// extracted by mini-css-extract-plugin
export default {"l_title_container_main":"TitleContainer_l_title_container_main__vFDEJ"};